import { render, staticRenderFns } from "./WhoWeServeComponent.vue?vue&type=template&id=2f688077&scoped=true&"
import script from "./WhoWeServeComponent.vue?vue&type=script&lang=js&"
export * from "./WhoWeServeComponent.vue?vue&type=script&lang=js&"
import style0 from "./WhoWeServeComponent.vue?vue&type=style&index=0&id=2f688077&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f688077",
  null
  
)

export default component.exports